/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Ear(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M188,152a28,28,0,0,1-56,0c0-15.67969,9.31152-23.66113,16.79346-30.07422C155.95068,115.791,160,111.93457,160,104a32,32,0,0,0-64,0,8,8,0,0,1-16,0,48,48,0,0,1,96,0c0,15.67969-9.31152,23.66113-16.79346,30.07422C152.04932,140.209,148,144.06543,148,152a12,12,0,0,0,24,0,8,8,0,0,1,16,0ZM128,16a88.09957,88.09957,0,0,0-88,88c0,33.49512,12.45557,45.50488,22.46387,55.15527C70.32227,166.73242,76,172.207,76,188a52.00105,52.00105,0,0,0,92.10742,33.09863,8,8,0,1,0-12.33594-10.18945A36.001,36.001,0,0,1,92,188c0-22.5918-9.7915-32.0332-18.43018-40.36328C64.53418,138.9248,56,130.69629,56,104a72,72,0,0,1,144,0,8,8,0,0,0,16,0A88.09957,88.09957,0,0,0,128,16Z" />
    </Svg>
  );
}

export default Ear;
